export const commonFields = {
    "fullName": "js-full-name",
    "email": "js-email",
    "telephone": "js-telephone",
    "message": "js-message",
};

/**
 * An object representing different categories of field usage for various forms.
 * Each key corresponds to a specific form.
 */
export const fieldUse = {
    "general-enquiry": {
        "formId": 1,
        "label": "General enquiry",
    },
    "development-production-funding": {
        "formId": 2,
        "label": "Development & production funding",
        "extraFields": {
            "projectName": "js-project-name",
            "projectStage": "js-project-stage",
        },
        "extraSections": [
            "js-rebate-section",
        ],
    },
    "film-festival-film-sales": {
        "formId": 3,
        "label": "Film festival & film sales",
        "extraFields": {
            "filmTitleFestivalName": "js-film-title-festival-name",
            "screeningOrSalesNeeds": "js-screening-or-sales-needs",
        },
    },
    "nz-screen-production-rebates": {
        "formId": 4,
        "label": "NZ screen production rebates",
        "extraFields": {
            "productionTitle": "js-production-title",
        },
        "extraSections": [
            "js-rebate-section",
        ],
    },
    "international-filming-in-new-zealand": {
        "formId": 5,
        "label": "International filming in New Zealand",
        "extraFields": {
            "productionTitle": "js-production-title",
            "expectedStartDate": "js-expected-start-date",
            "locationsOfInterest": "js-locations-of-interest",
        },
    },
    "aspiring-filmmaker-support": {
        "formId": 6,
        "label": "Aspiring Filmmaker Support",
    },
    "diversity-inclusion": {
        "formId": 7,
        "label": "Diversity & Inclusion",
    },
    "te-rautaki-maori": {
        "formId": 8,
        "label": "Te Rautaki Māori",
    },
    "legal-business-affairs": {
        "formId": 9,
        "label": "Legal & Business Affairs",
    },
    "media-enquiries": {
        "formId": 10,
        "label": "Media Enquiries",
    },
    "it-support": {
        "formId": 11,
        "label": "IT Support",
    },
    "curated-image-selection-service": {
        "formId": 12,
        "label": "Curated Image Selection Service",
        "extraFields": {
            "productionTitle": "js-production-title",
            "expectedStartDate": "js-expected-start-date",
            "locationsOfInterest": "js-locations-of-interest",
        },
    },
};
